import React from "react";

interface FileObject {
  id: number;
  name: string;
}
export interface FileHeaderProps {
  file: FileObject;
  onDelete: () => void;
}

export function FileHeader({ file, onDelete }: FileHeaderProps) {
  return (
    <div className='flex flex-row py-2 px-3 mt-2 rounded bg-gray-200 justify-between text-center align-middle '>
      <div className='text-gray-600 text-xs py-1 font-semibold'>{file.name}</div>
      <div>
        <button className='bg-gray-400 hover:bg-gray-500 border  text-white py-1 px-3 rounded text-xs' onClick={onDelete}>
          Eliminar
        </button>
      </div>
    </div>
  );
}